import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuItem from './menuItem'
import MenuTree from './menuTree'
import { withRouter } from 'react-router-dom';

import { carregarUsuario, logout } from '../../auth/authActions';

class Menu extends Component {

	state = {
		dashboardAberto: null,
		acessoAberto: null,
		cadastroAberto: null,
		precoAberto: null,
		vendaAberto: null,
		logisticaAberto: null,
		estoqueAberto: null,
		metaAberto: null,
		manutencaoAberto: null
	};

	constructor(props) {
		super(props);

		let idInterval = setInterval(() => {
			if (this.props.usuario) {
				this.props.carregarUsuario();
				clearInterval(idInterval);
			}
		}, 2000);
	}

	render() {

		if (this.props.usuario) {
			if (!this.props.usuario.administrador && (this.props.selecionado == '/admIdeiaNegocio')) {
				window.location = '/';
			}
			if (!this.props.usuario.administrador && (this.props.selecionado == '/admTrilhaConhecimento')) {
				window.location = '/';
			}
			if (!this.props.usuario.administrador && (this.props.selecionado == '/admVideo')) {
				window.location = '/';
			}
		}

		const { nome, login } = this.props.usuario;

		return (
			<div>
				<a className="nav-link" data-toggle="dropdown" href="#">
					<i className="fas fa-bars" style={{ color: '#ffffff' }}></i>
				</a>
				<div className="dropdown-menu dropdown-menu-lg dropdown-menu-right"
					style={{
						minWidth: window.innerWidth > 440 ? 400 : window.innerWidth - 40,
						marginTop: -20,
						marginRight: 20,
						backgroundColor: '#379DE2',
						opacity: 0.98
					}}>

					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							marginTop: 8,
							marginBottom: 16
						}}>							
						<MenuItem path='ideiaNegocio' label='Inscrição para Pré-Incubação' active={this.props.selecionado == '/' || this.props.selecionado == '/ideiaNegocio'} />						
						<MenuItem path='trilhaConhecimento' label='Trilha de Pré-Incubação' active={this.props.selecionado == '/trilhaConhecimento'} />
					
						<MenuItem path='incubacaoSelecao' label='Inscrição para Incubação' active={this.props.selecionado == '/incubacaoSelecao'} />
						<MenuItem path='incubacao' label='Trilha de Incubação' active={this.props.selecionado == '/incubacao'} />

						<MenuItem path='dicionario' label='Dicionário de Startups' active={this.props.selecionado == '/dicionario'} />						
						<MenuItem path='parceiro' label='Parceiros' active={this.props.selecionado == '/parceiro'} />						
						<MenuItem path='mentor' label='Mentores' active={this.props.selecionado == '/mentor'} />						
						<MenuItem path='startup' label='Startups' active={this.props.selecionado == '/startup'} />						
						<MenuItem path='evento' label='Agenda' active={this.props.selecionado == '/evento'} />
						<MenuItem path='oportunidade' label='Oportunidade' active={this.props.selecionado == '/oportunidade'} />
						
						{this.props.usuario.administrador &&
						<MenuItem path='admIdeiaNegocio' label='Adm - Ideias de Negocios' active={this.props.selecionado == '/admIdeiaNegocio'} />}
						
						{this.props.usuario.administrador &&
						<MenuItem path='admTrilhaConhecimento' label='Adm - Trilha de Conhecimento' active={this.props.selecionado == '/admTrilhaConhecimento'} />}

						{this.props.usuario.administrador &&
						<MenuItem path='admIncubacaoSelecao' label='Adm - Inscrição Incubação' active={this.props.selecionado == '/admIncubacaoSelecao'} />}

						{this.props.usuario.administrador &&
						<MenuItem path='admIncubacao' label='Adm - Trilha de Incubação' active={this.props.selecionado == '/admIncubacao'} />}

						{/*this.props.usuario.administrador &&
						<MenuItem path='admAvaliacao' label='Adm - Banca de Avaliação' active={this.props.selecionado == '/admAvaliacao'} />*/}

						{this.props.usuario.administrador &&
						<MenuItem path='admVideo' label='Adm - Vídeo' active={this.props.selecionado == '/admVideo'} />}

						<li className="nav-item" onClick={this.props.logout}>
							<div className={`nav-link`} style={{ padding: 0 }}>
								<p 
									style={{ 
										color: '#ffffff',
										fontWeight: 'bold',
										fontSize: 18,
										textAlign: 'center',
										padding: 12
									}}>
									Sair
								</p>
							</div>
						</li>
					</div>

				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	usuario: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado
});
const mapDispatchToProps = dispatch => bindActionCreators({ carregarUsuario, logout }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
